/**
 * UserTableError - Error state component for user table.
 *
 * Displays an error message in a Card wrapper.
 */

import { Card, CardContent } from '@lean-agility/design-system/react';

export interface UserTableErrorProps {
  /**
   * Error message to display.
   */
  message: string;
}

export function UserTableError({ message }: UserTableErrorProps) {
  return (
    <div className="container mx-auto px-4 py-8">
      <Card>
        <CardContent className="p-6">
          <p className="text-feedback-error">{message}</p>
        </CardContent>
      </Card>
    </div>
  );
}
